module.exports = __webpack_public_path__ + "img/groomers_choice-2Zv4SHy.svg";